"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var variables_1 = require("../../../style/variables");
var layout_1 = require("../../layout");
var getButtonStyle = function () { return ({
    base: react_1.css({
        height: 32,
        width: 32,
        margin: 8,
    }),
    default: react_1.css({
        color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")",
        ':hover': {
            color: "var(" + variables_1.RootColor.Gray.DARK_3 + ")",
            background: "var(" + variables_1.RootColor.Gray.LIGHT_4 + ")",
            borderRadius: 6,
        },
    }),
    selected: react_1.css({
        color: "var(" + variables_1.RootColor.Blue.DARK_1 + ")",
        background: "var(" + variables_1.RootColor.Blue.LIGHT_5 + ")",
        borderRadius: 6,
    }),
    disabled: react_1.css({
        color: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
    }),
}); };
var RichTextEditorToolbarButton = function (_a) {
    var Icon = _a.icon, props = __rest(_a, ["icon"]);
    var onToggle = function (e) {
        e.preventDefault();
        props.onClick(props.style, props.buttonType);
    };
    var style = react_2.useMemo(function () { return getButtonStyle(); }, []);
    return (react_1.jsx(layout_1.Flex, { onMouseDown: onToggle, justifyContent: "center", alignItems: "center", css: [
            style.base,
            !(props.selected || props.disabled) ? style.default : undefined,
            props.selected && !props.disabled ? style.selected : undefined,
            props.disabled ? style.disabled : undefined,
        ] },
        react_1.jsx(Icon, { strokeWidth: 1 })));
};
exports.default = RichTextEditorToolbarButton;
